import React, { useEffect, useState } from "react";
import { API_ENDPOINT } from "../../../services/api/resources";
import { useSelector } from "react-redux/es/hooks/useSelector";
import axios from "axios";
import InfoLabel from "../../../components/common/InfoLabel/InfoLabel";
import classes from "./RFQTab.module.css";

import TextArea from "../../../components/common/TextArea/TextArea";
import DSelectInput from "../../../components/Dashboard/DashboardInputs/DSelectInput";
import DButton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import PopupFrame from "../../../components/Popups/PopupFrame/PopupFrame";
import Attachment from "../../../components/common/Attachment/Attachment";
import DFreeSoloInput from "../../../components/Dashboard/DashboardInputs/DFreeSoloInput";

import { Fade, Modal, Box, TextField, RadioGroup, FormControlLabel, Radio } from "@mui/material";

import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import { MoreHoriz } from "@mui/icons-material";
import DButtonOutlined from "../../../components/Dashboard/DashboardButtons/dButtonOutlined";
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import { DatePicker, LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { emptyCheck, validateEmail } from "../../../utils/validations";
import vendorClasses from "../VendorsTab/VendorsTab.module.css";
import { useNavigate, useLocation } from "react-router-dom";

dayjs.extend(utc);



const QuickRFQ = ({ closeQuickRFQ }) => {

    const loginData = useSelector((state) => state.loginData.value);



    const [buyer_token] = useState(loginData?.user?.token);
    const [auth_token] = useState(loginData?.auth_token);
    const [user_token] = useState(loginData?.user?.token);
    const [org_name] = useState(loginData?.user?.company_name);


    const [getrfq, setRFQs] = useState([]);
    const [items, setItems] = useState([]);
    const [address, setAddress] = useState([]);


    const unitsOptions = [
        "Assemblies",
        "Dozen",
        "Each",
        "Feet",
        "Gallons",
        "Kilo",
        "Liters",
        "Metric Tons",
        "Meters",
        "Pieces",
        "Pounds",
        "Sets",
        "Tons",
        "Yards  ",
    ];


    // vendor list
    const [vendorsList, setVendorsList] = useState({
        values: {
            tokens: [],
            visibleOption: [],
        },
    });
    const [vendorId, setVendorID] = useState([]);
    const [vendor, setVendor] = useState({
        value: [],
        id: [],
        isValid: true,
    });

    const [vendormessage, setVendorMessage] = useState({
        send_message: "",
    });
    const [selectedaddress, setSelectedAddress] = useState(null)


    const [getItemMaster, setItemMaster] = useState([])

    const [openvendormodal, setOpenModal] = useState(false)
    const [charsLeft, setCharsLeft] = useState(0);
    const [errorMessages, setErrorMessages] = useState(false);

    const [showmessagebtn, setMessageBtn] = useState(false)
    const [sendbtntext, setSendBtnText] = useState(false)

    const [successpopup, setSuccessPopUp] = useState(false);
    const [getuserpopupherotext, setUserPopupHeroText] = useState("");

    const [savedrfqtoken, setSavedRFQToken] = useState({})
    const [getvendorfileupload, setVendorFileUpload] = useState([]);

    const [openaddvendor, setOpenAddVendor] = useState(false);
    const [CompanyName, setCompanyName] = useState({
        value: "",
        errorMsg: "",
        isValid: true,
    });
    const [companyList, setCompanyList] = useState([]);
    const [VendorRegisteredEmail, setVendorRegisteredEmail] = useState({
        value: "",
        errorMsg: "",
        isValid: true,
    });
    const [loading, setLoading] = useState(false);
    const [primaryBtnError, setPrimaryBtnError] = useState({
        error: false,
        errorMsg: "",
    });

    const [prNumber, setPrNumber] = useState("");


    const [openAddAddressModal, setOpenAddAddressModal] = useState(false);




    const [bidstartdate, setBidStartDate] = useState(dayjs());
    const [bidenddate, setBidEndDate] = useState(dayjs().add(1, "day"));
    // const [bidendtime, setBitEndTime] = useState(dayjs());
    // const [bidendtime, setBitEndTime] = useState(dayjs().add(1, "day").endOf("day").utc().hour(23).minute(59).second(0).millisecond(0));
    const [bidendtime, setBitEndTime] = useState(
        dayjs().utc().hour(11).minute(59).second(0).millisecond(0)
    );

    const [fileUpload, setFileUpload] = useState(null);
    const [inputMethod, setInputMethod] = useState("xls");
    const [bidType, setBidType] = useState("0");
    const [proposalDoc, setProposalDoc] = useState("");

    const [dragging, setDragging] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();





    // useEffect(() => {
    //     const today = new Date();
    //     const tomorrow = new Date();
    //     tomorrow.setDate(today.getDate() + 1);

    //     const formatDate = (date) => date.toISOString().split("T")[0];
    //     const defaultTime = "12:00:00.000Z";
    //     const nowtime = new Date().getTime()

    //     setBidStartDate(formatDate(today) + "T" + defaultTime);
    //     setBidEndDate(formatDate(tomorrow) + "T" + defaultTime);
    // }, []);

    useEffect(() => {
        setBidStartDate(dayjs());
        setBidEndDate(dayjs().add(1, "day"));
        setBitEndTime(dayjs().add(1, "day").endOf("day"));
    }, []);



    const get_rfqs = async () => {
        try {
            const response = await axios({
                url: `${API_ENDPOINT.get_all_buyer_RFQ}`,
                method: "POST",
                data: {
                    "page": 1,
                    "org_token": buyer_token
                },
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                },
            });

            setRFQs(response.data.results || []);
        } catch (error) {
            console.error("Error fetching RFQs:", error);
            setRFQs([]);
        }
    };

    const get_all_vendors = async () => {
        await axios({
            method: "POST",
            url: `${API_ENDPOINT.get_all_vendor}`,
            data: {
                org_token: buyer_token,
            },
            headers: {
                Authorization: `Bearer ${auth_token}`,
            },
        })
            .then((res) => {
                setVendorsList({
                    values: {
                        tokens: res?.data?.users.map((vendor) => vendor.token),
                        visibleOption: res?.data?.users.map((vendor) => `${vendor.company_name} (${vendor.company_official_email})`),
                    },
                    fullDetails: res?.data?.users.reduce((acc, vendor) => {
                        acc[vendor.token] = {
                            token: vendor.token,
                            companyName: vendor.company_name,
                            email: vendor.company_official_email,
                            role: vendor.role,
                        };
                        return acc;
                    }, {}),
                })
            }
            )
    }

    const getAllItems = async () => {
        try {
            const response = await axios.post(
                `${API_ENDPOINT.view_all_item}`,
                { org_token: user_token },
                { headers: { Authorization: `Bearer ${auth_token}` } }
            );

            if (response.data?.response) {

                setItemMaster(response?.data?.response);
            } else {
                console.error("API response is not an array:", response.data);
                setItemMaster([]);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setItemMaster([]);
        }
    };

    const get_rfq_address = async () => {
        try {
            const response = await axios({
                url: `${API_ENDPOINT.rfq_address}`,
                method: "POST",
                data: {
                    "buyer_token": buyer_token
                },
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                },
            });

            setAddress(response.data || []);
        } catch (error) {
            console.error("Error fetching RFQs:", error);
            setAddress([]);
        }
    };

    useEffect(() => {
        get_rfqs();
        get_all_vendors()
        getAllItems()
        get_rfq_address()
    }, []);


    const org_details = [
        {
            label: "RFQ Code",
            size: "30rem",
        },
        // {
        //     label: "Bid Type",
        //     value: "Closed",
        //     size: "10rem",
        // },
        // {
        //     label: "Proposal Document",
        //     value: "No",
        //     size: "14rem",
        // }
    ];

    const rfqData = getrfq?.map(rfq => {
        const match = rfq.rfq_code.match(/RFQ_(\d+)\/([^\/]+)\/([\d-]+)\/([A-Z]+)/);
        if (match) {
            return {
                number: parseInt(match[1]),
                organization: match[2]
            };
        }
        return null;
    }).filter(item => item !== null) || [];

    const nextRFQNumber = rfqData.length > 0 ? Math.max(...rfqData.map(item => item.number)) + 1 : 1000;
    const organizationName = rfqData.length > 0 ? rfqData[rfqData.length - 1].organization : "Default Org";

    const currentYear = new Date().getFullYear();
    const nextYear = currentYear + 1;
    const financialYear = `${currentYear}-${nextYear}`;
    const currentMonth = new Date().toLocaleString('en-US', { month: 'short' }).toUpperCase();

    const newRfqCode = `Q-RFQ_${nextRFQNumber}/${organizationName}/${financialYear}/${currentMonth}/${prNumber}`;
    org_details[0].value = newRfqCode;

    const addNewItem = () => {
        setItems([...items, { itemName: "", itemCode: "", hsnCode: "", unspscCode: "", unit: "", quantity: "", description: "" }]);
    };

    const handleInputChange = (index, field, value) => {
        const updatedItems = [...items];
        updatedItems[index][field] = value;
        setItems(updatedItems);
    };

    const removeItem = (index) => {
        const updatedItems = items.filter((_, i) => i !== index);
        setItems(updatedItems);
    };


    const handleVendorSelection = (value) => {
        setVendor({
            value: value,
            isValid: value?.length !== 0,
        });
    };

    const handleWordCount = (event) => {
        const inputValue = event.target.value;
        const charCount = inputValue.length;
        const maxChar = 2000;
        const truncatedValue = inputValue.slice(0, maxChar);
        setVendorMessage({ ...vendormessage, send_message: truncatedValue });
        const charLength = Math.min(maxChar, charCount); // Ensures the count doesn't exceed 200
        setCharsLeft(charLength);
    };


    const handleVendorMessagePopup = () => {
        setOpenModal(true)
    }

    const handleVendorMessageClosePopup = () => {
        setVendorMessage({ ...vendormessage, send_message: "" });
        setOpenModal(false)
    }


    const handleuserFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setVendorFileUpload((prefiles) => [...prefiles, file]);
        }
    };

    const handleUserRemoveFile = (index) => {
        setVendorFileUpload((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };



    const handleSendVendorMessage = async () => {

        // let requestData = {
        //     sender_token: user_token,
        //     sender_role: loginData?.user?.role,
        //     receiver_token: vendor?.fullDetails.map(item => item.token).join(","),
        //     receiver_role: vendor?.fullDetails.map(item => item.role).join(","),
        //     rfq_token: savedrfqtoken.rfq_token,
        //     message: vendormessage.send_message,
        //     rfqcon_files:
        // }

        // // rfqcon_files:getvendorfileupload,
        // if (getvendorfileupload && getvendorfileupload.length > 0) {
        //     requestData.rfqcon_files = getvendorfileupload;
        // }

        let formData = new FormData();

        // Append text fields
        formData.append("sender_token", user_token);
        formData.append("sender_role", loginData?.user?.role);
        formData.append("receiver_token", vendor?.fullDetails.map(item => item.token).join(",")); // Comma-separated tokens
        formData.append("receiver_role", vendor?.fullDetails.map(item => item.role).join(",")); // Comma-separated roles
        formData.append("rfq_token", savedrfqtoken.rfq_token);
        formData.append("message", vendormessage.send_message);

        if (getvendorfileupload) {
            getvendorfileupload.forEach(file => {
                formData.append('rfqcon_files', file)

            })
        }

        try {
            const res = await axios.post(API_ENDPOINT.rfq_chat, formData, {
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            if (res?.data?.response == "Message sent.") {
                setSuccessPopUp(true)
                setUserPopupHeroText("Message Sent Successfully!!")
            }

        } catch (error) {
            console.error("Error:", error.response?.data || error.message);
        }

    };



    const vendorMessageHeader = (
        <HeaderTitle
            titleText={"Send Message" || <MoreHoriz sx={{ fontSize: "30px" }} />}
            customclass={classes.heading_pop_pup}
        />
    );

    const vendorTextArea = [
        <div>
            <p className={classes.heading_sub_text}>Please enter your message</p>
            <TextArea
                maxLength="2000"
                style={{ width: "100 %" }}
                title="send_message"
                name="send_message"
                rows={7}
                value={vendormessage.send_message}
                placeholder="Type your message hear..."
                onChange={handleWordCount}
            />
            {charsLeft === 2000 && (
                <p className={classes.error_msg}>
                    Message should be less than 2000 characters only
                </p>
            )}
            {errorMessages ? (
                <p className={classes.error_msg}>Please fill above message field</p>
            ) : (
                ""
            )}
            <Attachment
                msg_file={getvendorfileupload}
                handleFileChange={handleuserFileChange}
                handleRemoveFile={handleUserRemoveFile}
            />
        </div>,
    ];

    const vendorActionBtn = [
        <DButtonOutlined
            label={"Cancel"}
            onClick={handleVendorMessageClosePopup}
            btnWidth={"17rem"}
            btnHeight={"4rem"}
        />,
        <DButton
            label={sendbtntext && !errorMessages ? "Sending" : "Send Message"}
            btnWidth={"17rem"}
            btnHeight={"4rem"}
            onClick={handleSendVendorMessage}
        //   disabled={sendmsg && !errorMessages}
        />,
    ];

    const handleItemSelection = (index, selectedItem) => {
        const updatedItems = [...items];
        const itemData = getItemMaster.find((item) => item.item_name === selectedItem);

        if (itemData) {
            updatedItems[index] = {
                itemName: itemData.item_name,
                itemCode: itemData.item_code,
                hsnCode: itemData.hsn_code,
                unspscCode: itemData.unspsc_code || "",
            };
        }

        setItems(updatedItems);
    };

    const handleAddressSelection = (items) => {
        setSelectedAddress(items)
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setFileUpload(file);
    };


    const handleDragOver = (event) => {
        event.preventDefault();
        setDragging(true);
    };

    const handleDragLeave = (event) => {
        event.preventDefault();
        setDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        setDragging(false);
        const file = event.dataTransfer.files[0];
        if (file) {
            setFileUpload(file);
        }
    };

    // const handleQuickRFQSave = async () => {


    //     let transformedData = {}
    //     org_details.forEach(item => {
    //         transformedData[item.label] = item.value
    //     })

    //     let finalData = {
    //         ...transformedData,
    //         purchase_request_number: prNumber
    //     };


    //     let newlyAddedVendors = vendor.value.filter(vendorItem =>
    //         !vendorsList.values.visibleOption.includes(vendorItem)
    //     );

    //     let transformedVendor = newlyAddedVendors.map(vendorItem =>
    //         vendorItem.replace(/(.*?)\s\((.*?)\)/, "$1|$2")
    //     );


    //     let finaVendorData = {
    //         buyer_token: buyer_token,
    //         vendor_details: transformedVendor
    //     }

    //     console.log(finaVendorData)

    //     const res = await axios.post(API_ENDPOINT.rfq_add_new_vendor, finaVendorData, {
    //         headers: {
    //             Authorization: `Bearer ${auth_token}`,
    //             "Content-Type": "application/json",
    //         },
    //     });

    //     const newVendors = res?.data?.response.map(vendor => ({
    //         token: vendor.token,
    //         companyName: vendor.company_name,
    //         email: vendor.company_official_email
    //     })) || [];

    //     const vendorInfo = [
    //         ...vendor.fullDetails.map(({ token, companyName, email }) => ({
    //             token,
    //             companyName,
    //             email
    //         })),
    //         ...newVendors
    //     ];

    //     const formData = {
    //         user_token,
    //         items,
    //         ...finalData,
    //         ...selectedaddress,
    //         vendorInfo,
    //         bid_from_date: bidstartdate.utc().format("YYYY-MM-DDT00:00:00.000000[Z]"),
    //         bid_to_date: bidenddate.utc().format("YYYY-MM-DDT00:00:00.000000[Z]"),
    //         bid_time: bidendtime.utc().hour(11).minute(59).second(0).millisecond(0).format("YYYY-MM-DDTHH:mm:ss.SSSSSS[Z]")
    //     }

    //     console.log(formData)

    //     const saverfq = await axios.post(API_ENDPOINT.save_quick_rfq, formData, {
    //         headers: {
    //             Authorization: `Bearer ${auth_token}`,
    //             "Content-Type": "application/json",
    //         },
    //     });


    //     if (saverfq?.status == 200) {
    //         setSuccessPopUp(true);
    //         setSavedRFQToken(saverfq?.data)
    //         setUserPopupHeroText(saverfq?.data?.response)
    //         sendNewRFQToken(saverfq?.data?.rfq_token)

    //     }

    // };




    const handleQuickRFQSave = async () => {
        let transformedData = {};
        org_details.forEach((item) => {
            transformedData[item.label] = item.value;
        });

        let finalData = {
            ...transformedData,
            purchase_request_number: prNumber,
        };

        // ✅ Ensure Vendor Data is Properly Structured
        let vendorInfoArray = [];
        if (typeof vendor.fullDetails === "object" && vendor.fullDetails !== null) {
            vendorInfoArray = Object.values(vendor.fullDetails).map((vendorItem) => ({
                token: vendorItem.token,
                companyName: vendorItem.companyName,
                email: vendorItem.email,
            }));
        }

        let formData = new FormData();

        formData.append("user_token", user_token);
        formData.append("RFQ Code", finalData["RFQ Code"]);
        formData.append("Bid Type", bidType);
        formData.append("Proposal Document", proposalDoc);
        formData.append("purchase_request_number", prNumber);
        formData.append("shipping_address1", selectedaddress?.shipping_address1 || "");
        formData.append("shipping_address2", selectedaddress?.shipping_address2 || "");
        formData.append("city", selectedaddress?.city || "");
        formData.append("state", selectedaddress?.state || "");
        formData.append("country", selectedaddress?.country || "");
        formData.append("mobile_number", selectedaddress?.mobile_number || "");
        formData.append("pincode", selectedaddress?.pincode || "");

        formData.append("bid_from_date", bidstartdate.utc().format("YYYY-MM-DDT00:00:00.000000[Z]"));
        formData.append("bid_to_date", bidenddate.utc().format("YYYY-MM-DDT00:00:00.000000[Z]"));
        formData.append(
            "bid_time",
            bidendtime.utc().format("YYYY-MM-DDTHH:mm:ss.SSSSSS[Z]")
        );

        formData.append("vendorInfo", JSON.stringify(vendorInfoArray));

        if (inputMethod === "manual") {
            formData.append("items", JSON.stringify(items));
        } else if (fileUpload) {
            formData.append("item_code_xlsx", fileUpload);
        }

        try {
            const response = await axios.post(API_ENDPOINT.save_quick_rfq, formData, {
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response?.status === 200) {
                setSuccessPopUp(true);
                setSavedRFQToken(response?.data);
                setUserPopupHeroText(response?.data?.response);
                sendNewRFQToken(response?.data?.rfq_token);
            }
        } catch (error) {
            console.error("Error saving RFQ:", error.response?.data || error.message);
        }
    };



    const sendNewRFQToken = async (token) => {
        await axios({
            method: "POST",
            url: `${API_ENDPOINT.rfq_newversion_chatgpt}`,
            data: {
                rfq_token: token,
            },
            headers: {
                Authorization: `Bearer ${auth_token}`,
            },
        })
            .then((res) => {
                console.log(res);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const clearAllState = () => {
        setSuccessPopUp(false);
        setOpenModal(false)
        setMessageBtn(true)
        navigate("/Buyer_dashboard/RFQ")
    };



    // add vendor

    const getCompanyList = async (searchValue) => {
        let abortController = new AbortController();
        try {
            abortController.abort();

            const newAbortController = new AbortController();
            abortController = newAbortController;

            const formData = new FormData();
            formData.append("buyer_token", buyer_token);
            formData.append("search", searchValue);

            const response = await axios({
                method: "POST",
                url: `${API_ENDPOINT.getCompanyList}`,
                data: formData,
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                },
                signal: abortController.signal,
            });

            let responseData = response?.data?.response;
            setCompanyList(responseData?.map((e) => e?.company_name));
        } catch (error) {
            if (error.name === "AbortError") {
                console.log("Request aborted:", error.message);
            } else {
                console.log(error);
            }
        }
    };




    const vendorsTabInputs = [
        <DFreeSoloInput
            label="Company Name"
            value={CompanyName.value}
            options={companyList}
            onChange={(value) => {
                if (openaddvendor) {
                    setCompanyName({
                        value: value,
                        isValid: emptyCheck(value),
                    });
                }
                if (value?.length > 2) {
                    getCompanyList(value);
                } else {
                    setCompanyList([]);
                }
            }}
            error={!CompanyName.isValid}
            errorMsg={"Company name is required"}
            size={"100%"}
        />,
        <DTextInput
            label={"Email"}
            value={VendorRegisteredEmail.value}
            onChange={(e) => {
                let val = e.target.value;
                const arr = [];
                vendorId.forEach((item, i) => {
                    if (item === undefined) {
                        //extracting mail id from vendor
                        arr.push(vendor.value[i]?.split("(")[1]?.replace(")", ""));
                    }
                });
                //checking if the vendor mail exists
                if (arr.some((item) => item === val)) {
                    setVendorRegisteredEmail({
                        value: val,
                        isValid: false,
                        message: "vendor already selected",
                    });
                } else {
                    setVendorRegisteredEmail({
                        value: val,
                        isValid: validateEmail(val),
                    });
                }
            }}
            error={!VendorRegisteredEmail.isValid}
            errorMsg={
                !emptyCheck(VendorRegisteredEmail.value)
                    ? "Email is required"
                    : VendorRegisteredEmail?.message
                        ? VendorRegisteredEmail?.message
                        : !VendorRegisteredEmail.isValid
                            ? "Invalid email format"
                            : "" || ""
            }
            customClassName={vendorClasses.addVendorPopupInput}
            size={"100%"}
        />,
    ];

    const vendorsTabHeading = (
        <HeaderTitle
            titleText={"Add Vendors"}
            customclass={vendorClasses.popupHeading}
        />
    );

    const handleAddNewVendor = (e) => {
        e.stopPropagation();

        const isEmailValid = validateEmail(VendorRegisteredEmail.value);
        const isCompanyValid = emptyCheck(CompanyName.value);

        setCompanyName((prev) => ({ ...prev, isValid: isCompanyValid }));
        setVendorRegisteredEmail((prev) => ({ ...prev, isValid: isEmailValid }));

        if (isEmailValid && isCompanyValid) {
            setLoading(true);
            axios({
                method: "POST",
                url: `${API_ENDPOINT.rfq_vendor_email_verification}`,
                data: {
                    email: VendorRegisteredEmail.value,
                    buyer_token: buyer_token,
                },
                headers: {
                    Authorization: `Bearer ${auth_token}`,
                },
            })
                .then((response) => {
                    if (response.status === 200) {
                        setVendor((prev) => ({
                            ...prev,
                            isValid: true,
                            value: [
                                ...prev.value,
                                `${CompanyName.value} (${VendorRegisteredEmail.value})`,
                            ],
                        }));
                    }
                    handleClose1();
                    setLoading(false);
                })
                .catch((e) => {
                    setVendorRegisteredEmail((prev) => ({
                        ...prev,
                        message: e.response.data.response,
                        isValid: false,
                    }));
                    setLoading(false);
                });
        }
    };


    // const handleAddNewVendor = async (e) => {
    //     e.stopPropagation();

    //     const isEmailValid = validateEmail(VendorRegisteredEmail.value);
    //     const isCompanyValid = emptyCheck(CompanyName.value);

    //     setCompanyName((prev) => ({ ...prev, isValid: isCompanyValid }));
    //     setVendorRegisteredEmail((prev) => ({ ...prev, isValid: isEmailValid }));

    //     if (isEmailValid && isCompanyValid) {
    //         setLoading(true);
    //         try {
    //             const response = await axios.post(
    //                 `${API_ENDPOINT.rfq_vendor_email_verification}`,
    //                 {
    //                     email: VendorRegisteredEmail.value,
    //                     buyer_token: buyer_token,
    //                 },
    //                 { headers: { Authorization: `Bearer ${auth_token}` } }
    //             );

    //             console.log(response)

    //             if (response.status === 200) {
    //                 const newVendor = {
    //                     token: response.data.token,
    //                     companyName: CompanyName.value,
    //                     email: VendorRegisteredEmail.value,
    //                     role: "vendor", // Assuming role is "vendor"
    //                 };

    //                 // ✅ Update vendor list to include the new vendor
    //                 setVendorsList((prev) => ({
    //                     values: {
    //                         tokens: [...prev.values.tokens, newVendor.token],
    //                         visibleOption: [
    //                             ...prev.values.visibleOption,
    //                             `${newVendor.companyName} (${newVendor.email})`,
    //                         ],
    //                     },
    //                     fullDetails: {
    //                         ...prev.fullDetails,
    //                         [newVendor.token]: newVendor,
    //                     },
    //                 }));

    //                 // ✅ Add new vendor to the selected vendors
    //                 setVendor((prev) => ({
    //                     ...prev,
    //                     value: [
    //                         ...prev.value,
    //                         `${newVendor.companyName} (${newVendor.email})`,
    //                     ],
    //                     fullDetails: [...prev.fullDetails, newVendor], // Add new vendor to details list
    //                     isValid: true,
    //                 }));
    //             }

    //             handleClose1();
    //         } catch (e) {
    //             setVendorRegisteredEmail((prev) => ({
    //                 ...prev,
    //                 message: e.response.data.response,
    //                 isValid: false,
    //             }));
    //         } finally {
    //             setLoading(false);
    //         }
    //     }
    // };


    const handleOpen1 = () => setOpenAddVendor(true);

    const handleClose1 = () => {
        setOpenAddVendor(false);
        setVendorRegisteredEmail({
            value: "",
            errorMsg: "",
            isValid: true,
        });
        setCompanyName({
            value: "",
            errorMsg: "",
            isValid: true,
        });
    };

    const popupActions = [
        <DButtonOutlined
            label={"Cancel"}
            onClick={handleClose1}
            btnWidth={"17rem"}
            btnHeight={"4rem"}
            buyerBtn={true}
        />,
        <DButton
            label={"Add"}
            btnWidth={"17rem"}
            btnHeight={"4rem"}
            buyerBtn={true}
            error={primaryBtnError.error}
            errorMsg={primaryBtnError.errorMsg}
            loadingState={loading}
            onClick={handleAddNewVendor}
        />,
    ];

    const handleNavigate = () => {
        navigate("/Buyer_dashboard/RFQ")
    }

    const isRFQPage = location.pathname === "/Buyer_dashboard/RFQ";


    return (
        <div style={{ padding: "10px 12px" }}>

            {/* <HeaderTitle titleText={"Quick RFQ"}/> */}

            <div className={classes.quickrfqinfo}>

                <div style={{ display: "flex" }}>

                    {org_details.map((e, i) => (
                        <InfoLabel
                            key={i}
                            label={e.label}
                            value={e.value}
                            size={e.size}
                        />
                    ))}

                    <div className={classes.bidtype}>
                        <p>Bid Type</p>
                        <RadioGroup
                            row
                            value={bidType}
                            onChange={(e) => {
                                console.log(e.target.value)
                                setBidType(e.target.value)}}
                        >
                            <FormControlLabel value="1" control={<Radio />} label="Auction" sx={{ "& .MuiTypography-root": { fontSize: "14px" } }} />
                            <FormControlLabel value="0" control={<Radio />} label="Closed" sx={{ "& .MuiTypography-root": { fontSize: "14px" } }} />
                        </RadioGroup>
                    </div>
                </div>

                {!isRFQPage && <div>
                    <DButton label={"RFQ"} onClick={handleNavigate} />
                </div>}


            </div>

            <div className={classes.detailscontainer}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div className={classes.datewrapper}>
                        <label>From Date</label>
                        <DatePicker
                            format="DD/MM/YYYY"
                            value={bidstartdate}
                            onChange={(newValue) => setBidStartDate(dayjs(newValue).utc())}
                            sx={{
                                "& .MuiInputBase-input": { fontSize: "12px", color: "#333" }
                            }}
                            renderInput={(params) => <TextField {...params} className="border p-2 rounded" />}
                        />
                    </div>
                    <div className={classes.datewrapper} >
                        <label>To Date</label>

                        <DatePicker
                            format="DD/MM/YYYY"
                            value={bidenddate}
                            onChange={(newValue) => setBidEndDate(newValue)}
                            sx={{
                                "& .MuiInputBase-input": { fontSize: "12px", color: "#333" }
                            }}
                            renderInput={(params) => <TextField {...params} className="border p-2 rounded" />}
                        />
                    </div>
                    <div className={classes.datewrapper}>
                        <label>End Time</label>

                        <MobileTimePicker
                            value={bidendtime}
                            sx={{
                                "& .MuiInputBase-input": { fontSize: "12px", color: "#333" }
                            }}
                            onChange={(newValue) => {
                                const updatedTime = dayjs(bidenddate)
                                    .hour(newValue.hour())
                                    .minute(newValue.minute())
                                    .second(0)
                                    .millisecond(0);
                                setBitEndTime(updatedTime); // Don't apply .utc() here
                            }}

                            renderInput={(params) => <TextField {...params} className="border p-2 rounded" />}
                        />
                    </div>

                </LocalizationProvider>

                <div className={classes.datewrapper}>
                    <label>Purchase Requisition Number</label>
                    <input onChange={(e) => setPrNumber(e.target.value)} value={prNumber} placeholder="Enter Purchase Requisition Number" />

                </div>
            </div>



            <div>
                <HeaderTitle titleText={"Items"} />

                <div>
                    <RadioGroup row value={inputMethod} onChange={(e) => setInputMethod(e.target.value)}>
                        <FormControlLabel value="xls" control={<Radio />} label="Attach RFQ document" sx={{ "& .MuiTypography-root": { fontSize: "14px" } }} />
                        <FormControlLabel value="manual" control={<Radio />} label="Type details of RFQ" sx={{ "& .MuiTypography-root": { fontSize: "14px" } }} />
                    </RadioGroup>
                </div>



                {
                    inputMethod === 'xls' ?

                        <div className={classes.docField}>
                            <div
                                className={`${classes.fileUploadWrapper} ${dragging ? classes.drag_over : ""}`}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}>
                                <div className={classes.file_upload}>
                                    {/* <label>{fileUpload && fileUpload.name}</label> */}
                                    <label className={classes.DocText}>
                                        <span>{fileUpload ? fileUpload.name : "Drag and drop file here"}</span>
                                        <input type="file" accept=".csv,.xlsx" style={{ display: "none" }} onChange={handleFileChange} />
                                        <p>(Supported format CSV/Excel)</p>
                                    </label>
                                    {!fileUpload ? <button onClick={() => document.querySelector('input[type="file"]').click()}>Browse</button> :
                                        <button onClick={() => setFileUpload(null)}>Clear</button>
                                    }
                                </div>
                                {/* {fileUpload && (
                                    <div className={classes.fileInfo}>
                                        <span>{fileUpload.name} ({(fileUpload.size / 1024).toFixed(2)} KB)</span>
                                        <button onClick={() => setFileUpload(null)}>Remove</button>
                                    </div>
                                )} */}
                            </div>
                            {/* <input type="file" accept=".csv, .xlsx" onChange={handleFileChange} /> */}
                        </div>
                        :
                        <table className={classes.quickrfq_table}>
                            <thead>
                                <tr>
                                    <th>Item Name</th>
                                    <th>Item Code</th>
                                    <th>HSN Code</th>
                                    <th>UNSPSC Code</th>
                                    <th>Unit</th>
                                    <th>Quantity</th>
                                    <th>Description</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <select
                                                value={item.itemName}
                                                onChange={(e) => handleItemSelection(index, e.target.value)}
                                            >
                                                <option value="">Select Item</option>
                                                {getItemMaster.map((itemOption) => (
                                                    <option key={itemOption.token} value={itemOption.item_name}>
                                                        {itemOption.item_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        {/* <Autocomplete
                                    options={getItemMaster}
                                    getOptionLabel={(option) => option.item_name}
                                    value={getItemMaster.find((itm) => itm.item_name === item.itemName) || null}
                                    onChange={(event, newValue) => handleItemSelection(index, newValue ? newValue.item_name : "")}
                                    renderInput={(params) => <TextField {...params} />}
                                /> */}
                                        <td><input type="text" value={item.itemCode} readOnly /></td>
                                        <td><input type="text" value={item.hsnCode} readOnly /></td>
                                        <td><input type="text" value={item.unspscCode} readOnly /></td>
                                        <td>
                                            <select
                                                value={item.unit}
                                                onChange={(e) => handleInputChange(index, "unit", e.target.value)}
                                            >
                                                <option value="">Select Unit</option>
                                                {unitsOptions.map((unit, idx) => (
                                                    <option key={idx} value={unit}>
                                                        {unit}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                value={item.quantity}
                                                onChange={(e) => handleInputChange(index, "quantity", e.target.value)}
                                                placeholder="Enter quantity"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                value={item.description}
                                                onChange={(e) => handleInputChange(index, "description", e.target.value)}
                                                placeholder="Enter description"
                                            />
                                        </td>
                                        <td>
                                            <button onClick={() => removeItem(index)}>Remove</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <div style={{ padding: "10px", float: "left" }}>
                                {/* <button onClick={addNewItem} className={classes.addItemButton}>+ Add Item</button> */}
                                <DButton
                                    onClick={addNewItem}
                                    label={"Add Items"}
                                    btnWidth={"17rem"}
                                    btnHeight={"4rem"}
                                />
                            </div>
                        </table>
                }
            </div>

            <div>

                <div>
                    <HeaderTitle titleText={"Shipping Address"} />
                    {/* <p>Add New Address</p> */}
                </div>

                <div className={classes.cardcontainer}>

                    {address.map((items, index) => {

                        return (
                            <div>
                                <div className={`${classes.card} ${selectedaddress === items ? classes.selectedCard : ""}`} onClick={() => handleAddressSelection(items)} >
                                    <input
                                        type="radio"
                                        name="shippingAddress"
                                        checked={selectedaddress === items}
                                        onChange={() => handleAddressSelection(items)}
                                        className={classes.radioButton}
                                    />
                                    <h3>{org_name}, {items.city}</h3>
                                    <p><strong>Address:</strong> {items.shipping_address1},{items.shipping_address2 || ""}</p>
                                    <p><strong>City:</strong> {items.city}</p>
                                    <p><strong>State:</strong> {items.state}</p>
                                    <p><strong>Country:</strong> {items.country}</p>
                                    <p><strong>Pincode:</strong> {items.pincode}</p>
                                    <p><strong>Mobile Number:</strong> {items?.mobile_number}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>

                {/* <div>
                    <div
                        className={`${classes.card} ${classes.addNewCard}`}
                        onClick={() => setOpenAddAddressModal(true)}
                    >
                        <h3>➕ Add New Address</h3>
                        <p>Click here to add a new shipping address</p>
                    </div>
                </div> */}

            </div>


            <HeaderTitle titleText={"Vendor"} />
            <div className={classes.quickvendorselect}>
                {/* <DSelectInput
                    customClass={classes.fields}
                    multiselect={true}
                    label="Select Vendor"
                    value={vendor.value}
                    options={vendorsList.values}
                    setIDValue={setVendorID}
                    onChange={(selectedValues) => {
                        // Extract selected vendor names
                        const selectedVendorNames = selectedValues.map((val) => val.split(" (")[0]);

                        // Filter only the selected vendors
                        const selectedVendors = vendorsList.values.tokens
                            .map((token, index) => ({
                                token,
                                companyName: vendorsList.values.visibleOption[index].split(" (")[0], // Extract name
                                email: vendorsList.values.visibleOption[index].match(/\((.*?)\)/)?.[1] || "", // Extract email

                            }))
                            .filter((vendor) =>
                                selectedValues.includes(`${vendor.companyName} (${vendor.email})`) // Only keep selected vendors
                            );

                        setVendor({
                            value: selectedValues, // Store selected names
                            fullDetails: selectedVendors, // Store correct vendor details
                            isValid: selectedValues.length !== 0,
                        });

                    }}
                    error={!vendor.isValid}
                    errorMsg={"Vendor is required"}
                    size={"100%"}
                /> */}

                <DSelectInput
                    customClass={classes.fields}
                    multiselect={true}
                    label="Select Vendor"
                    value={vendor.value}
                    options={vendorsList.values}
                    setIDValue={setVendorID}
                    onChange={(selectedValues) => {
                        // Extract selected vendor tokens
                        const selectedVendorTokens = selectedValues.map((val) => {
                            const vendor = Object.values(vendorsList.fullDetails).find(
                                (v) => `${v.companyName} (${v.email})` === val
                            );
                            return vendor ? vendor.token : null;
                        }).filter(Boolean);

                        // Filter only the selected vendors
                        const selectedVendors = selectedVendorTokens.map((token) => vendorsList.fullDetails[token]);
                        console.log(selectedVendors)

                        setVendor({
                            value: selectedValues, // ✅ Stores names/emails for the dropdown
                            fullDetails: selectedVendors, // ✅ Stores the vendor objects including role
                            isValid: selectedValues.length !== 0,
                        });
                    }}
                    error={!vendor.isValid}
                    errorMsg={"Vendor is required"}
                    size={"97%"}
                />



            </div>

            {/* <div className={classes.addvendor}>
                <p>Add Vendor ds</p>
                </div> */}


            {vendor.value.length > 0 && (
                <div className={classes.submitVendorContainer}>
                    {!showmessagebtn && <DButton
                        label={"Add Vendor"}
                        btnWidth={"17rem"}
                        btnHeight={"4rem"}
                        onClick={handleOpen1}
                    />}
                    {showmessagebtn && <DButton
                        label={"Message Vendor"}
                        btnWidth={"17rem"}
                        btnHeight={"4rem"}
                        onClick={handleVendorMessagePopup}
                    />}


                    {!showmessagebtn && <DButton
                        label={"Create RFQ"}
                        btnWidth={"17rem"}
                        btnHeight={"4rem"}
                        onClick={handleQuickRFQSave}
                    />}
                </div>
            )}

            <Modal
                open={openAddAddressModal}
                onClose={() => setOpenAddAddressModal(false)}
                closeAfterTransition
                slotProps={{
                    backdrop: { TransitionComponent: Fade },
                }}
            >
                <Fade in={openAddAddressModal}>
                    <Box className={classes.modalWrapper}>
                        <PopupFrame
                            poupHeading={<HeaderTitle titleText="Add New Address" />}
                            inputChildren={[
                                <div className={classes.addressForm}>
                                    <DTextInput label="Shipping Address 1" size="100%" />
                                    <DTextInput label="Shipping Address 2" size="100%" />
                                    <DTextInput label="City" size="100%" />
                                    <DTextInput label="State" size="100%" />
                                    <DTextInput label="Country" size="100%" />
                                    <DTextInput label="Pincode" size="100%" />
                                    <DTextInput label="Mobile Number" size="100%" />
                                </div>
                            ]}
                            actionButtons={[
                                <DButtonOutlined label="Cancel" onClick={() => setOpenAddAddressModal(false)} />,
                                // <DButton label="Add Address" onClick={handleAddAddressSubmit} />,
                            ]}
                        />
                    </Box>
                </Fade>
            </Modal>




            <Modal open={successpopup}>
                <Fade in={successpopup}>
                    <Box>
                        <SuccessPopupDashboard
                            popupImage={successPopupImg}
                            popupHeroText={getuserpopupherotext}
                            popBtn={true}
                            vendorBtn={true}
                            btnText={"Okay"}
                            btnClick={clearAllState}
                        />
                    </Box>
                </Fade>
            </Modal>

            <Modal open={openvendormodal}
                closeAfterTransition
                slotProps={{
                    backdrop: {
                        TransitionComponent: Fade,
                    },
                }}
            >
                <Fade in={openvendormodal}>

                    <div
                        className={classes.flex}
                        style={{
                            height: "130vh",
                        }}
                    >

                        <PopupFrame
                            poupHeading={vendorMessageHeader}
                            inputChildren={vendorTextArea}
                            actionButtons={vendorActionBtn}
                        />
                    </div>
                </Fade>
            </Modal>

            {/* add vendor */}


            <Modal
                open={openaddvendor}
                closeAfterTransition
                slotProps={{
                    backdrop: {
                        TransitionComponent: Fade,
                    },
                }}
                sx={{
                    overflow: "auto",
                }}
            >
                <Fade in={openaddvendor}>
                    <div
                        className={classes.flex}
                        style={{
                            height: "100vh",
                        }}
                    >

                        <PopupFrame
                            customClass={vendorClasses.InviteVendorPopup}
                            styleCenterDiv={classes.centerDiv}
                            inputChildren={vendorsTabInputs}
                            poupHeading={vendorsTabHeading}
                            actionButtons={popupActions}
                        />

                    </div>
                </Fade>
            </Modal>


        </div>
    );
}

export default QuickRFQ;
